module.exports = __webpack_public_path__ + "img/about_1.7996f085.png";